import { APIConfiguration } from '@savgroup-front-common/configuration';

const getCountryFlagsUrl = (countryCode: string) => {
  return `${
    APIConfiguration.catalogCDN
  }miscellaneous/flags/${countryCode.toLowerCase()}.svg`;
};

export default getCountryFlagsUrl;
